import React from "react";
import {
  Select,
  Space,
  Row,
  Col,
  message,
  Button,
  Modal,
  Tooltip,
  Checkbox,
  Image,
  Drawer,
  Avatar,
  Dropdown,
  Radio,
  ConfigProvider,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined, DeleteFilled, PlusOutlined } from "@ant-design/icons";
import config from "../config";
import InventoryStore from "../store/InventoryStore";
import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import CompanyAutocomplete from "./CompanyAutocomplete";
import WareHouseStore from "../store/WareHouseStore";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import InventoryAdd from "./InventoryAdd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import columnIcon from "../assets/images/NewDesign/column.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};

class InventoryList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.inventoryStore = new InventoryStore();
    this.wareHouseStore = new WareHouseStore();
    this.companyStore = new CompanyStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      warehouseList: [],
      warehouseId: "",
      companyVal_Lab: "",
      waslModal: false,
      inventoryName: "",
      inventoryId: "",
      openInventoryForm: false,
      listDataUpdate: false,
      modalVisible: false,
      deleteOption: 1,
      editData: {},
      openDeleteModal: false,
      deleteData: {},
      selectedColumns: [
        {
          // title: "Account",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
          dataIndex: "company",
          key: "company",
          width: "15%",
          render: (value, record) => {
            return (
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            );
          },
        },
        {
          // title: "Device",
          title: context.translate("_FLEET_GROUP_GROUPLIST_DEVICENAME_"),
          dataIndex: "device",
          key: "device",
          width: "15%",
        },
        {
          // title: "Warehouse",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_"),
          dataIndex: "warehouse",
          key: "warehouse",
          width: "15%",
        },
        {
          // title: "Inventory",
          title: context.translate("_INVENTORY_"),
          dataIndex: "inventory",
          key: "inventory",
          width: "15%",
        },
        {
          // title: "Inventory Number",
          title: context.translate("_INVENTORY_NUMBER_"),
          dataIndex: "inventoryNo",
          key: "inventoryNo",
          width: "15%",
        },
        {
          // title: "Storing Category",
          title: context.translate("_STORING_CATEGORY_"),
          dataIndex: "storingCategory",
          key: "storingCategory",
          width: "15%",
        },

        {
          // title: "Storing Type",
          title: context.translate("_STORING_TYPE_"),
          dataIndex: "storingType",
          key: "storingType",
          width: "15%",
        },
        {
          // title: "WASL Reply",
          // title: context.translate("_WAREHOUSE_WASL_REPLY_"),
          title: context.translate("SFDA Reply"),
          dataIndex: "waslReply",
          key: "waslReply",
          width: "15%",
        },
        // {
        //   // title: "WASL Response",
        //   title: context.translate("_WAREHOUSE_WASL_RESPONSE_"),
        //   dataIndex: "waslresponse",
        //   key: "waslresponse",
        //   width: "15%",
        // },

        {
          // title: "Action",
          title: context.translate("_ACTION_"),
          dataIndex: "action",
          key: "action",
          width: "15%",
          render: (_, record) => {
            // console.log(record)
            return (
              <>
                {/* <Space>
                
                  <DeleteConfirm
                    onConfirm={(e) => {
                      e.preventDefault();
                      this.onDelete(record);
                    }}
                  >
                    <Link>
                      <Tooltip
                        // title="Delete Record"
                        title={this.context.translate("_DELETE_RECORD_")}
                        placement="bottom"
                        color={config.tooltipColorDelete}
                      >
                        <DeleteFilled style={{ color: config.deleteColor }} />
                      </Tooltip>
                    </Link>
                  </DeleteConfirm>
                  <Link
                    onClick={async (e) => {
                      this.setState({ waslModal: true });
                      //  await this.getwarehouseId(record);
                      this.setState({ inventoryName: record.inventory });
                      console.log(record.inventory);
                      this.setState({ inventoryId: record.id });
                      console.log(record.id);
                    }}
                  >
                    <Tooltip
                      // title="Register in WASL"
                      title={this.context.translate("_REGISTER_IN_WASL_")}
                      placement="bottom"
                      color={config.tooltipColorEdit}
                    >
                      <PlusOutlined />
                    </Tooltip>
                  </Link>
                </Space> */}

                <Space style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip
                    // title="Register in WASL"
                    title={this.context.translate("_REGISTER_IN_WASL_")}
                    color="green"
                  >
                    <PlusOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "15px",
                        marginTop: "5px",
                      }}
                      onClick={async (e) => {
                        this.setState({
                          waslModal: true,
                          inventoryName: record.inventory,
                          inventoryId: record.id,
                        });
                      }}
                    />
                  </Tooltip>

                  <Tooltip
                    title={this.context.translate(
                      "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                    )}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    />
                  </Tooltip>
                  <Dropdown
                    // overlayClassName="export-dropdown"
                    menu={this.actionColumn}
                    trigger={["click"]}
                  >
                    <Image
                      style={{ cursor: "pointer" }}
                      src={kebabIcon}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ editData: record });
                      }}
                    ></Image>
                  </Dropdown>
                </Space>
              </>
            );
          },
        },
      ],
    };

    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.setState({ modalVisible: true })}
            >
              {" "}
              <Avatar
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={columnIcon}
              />
              {context.translate("_COLUMNS_")}
            </div>
          ),
          key: "columns",
        },
      ],
    };

    this.actionColumn = {
      items: [
        this.props.canUpdate("companyuserlist") && {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
      ],
    };

    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        // title: "Temperature",
        title: context.translate("_FLEET_REPORTS_TEMPREPORT_TEMPERATURE_"),
        dataIndex: "temperature",
        key: "temperature",
      },
      {
        // title: "Humidity",
        title: context.translate("_HUMIDITY_"),
        dataIndex: "humidity",
        key: "humidity",
      },
      {
        // title: "Sensor Id",
        title: context.translate("_SENSOR_ID_"),
        dataIndex: "sensorId",
        key: "sensorId",
      },
    ]);
  }

  onEdit = async (record) => {
    console.log(record.id);
    const Id = record.id;

    if (Id) {
      await this.context.viewStateStore.setInventoryStates(
        this.state.companyId,
        this.state.warehouseId
      );
      await this.setState({ inventoryId: Id });
      await this.setState({ openInventoryForm: true });
      // await this.props.navigate("/inventoryadd/" + Id);
    }
  };

  onDelete = async (record, deleteOption) => {
    const response = await this.inventoryStore.deleteRecord({
      inventoryId: record.id,
      waslWarehouseKey: record.waslWarehouseKey,
      option: deleteOption,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });

      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.inventoryStore.getWarehouselist({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    await this.setState({ column: this.state.selectedColumns });
    this.setState({ pageSize: 50 });
  }

  regiterWarehouse = async (inventoryId) => {
    console.log(inventoryId);
    const data = {
      inventoryId: inventoryId,
    };
    console.log(data);
    const response = await this.inventoryStore.addInventory(data);
    if (response?.success === "S") {
      message.success(response.message);
      this.props.navigate("/inventorylist");
    } else {
      // message.error("Warehouse Not Registered!");
      message.error(response.message);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    // if (
    //   this.state.openFuelFilledForm &&
    //   prevState.openFuelFilledForm !== this.state.openFuelFilledForm
    // ) {
    //   console.log("ilocasd");
    //   setTimeout(() => {
    //     window.dispatchEvent(new Event("resize"));
    //   }, 10);
    // }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setInventoryStates =
        this.context.viewStateStore.inventoryObject.companyId;
      if (setInventoryStates?.companyId !== "") {
        await this.inventoryStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setInventoryStates.companyId,
          warehouseId: setInventoryStates.warehouseId,
        });
        const data = await this.inventoryStore.getWarehouselist({
          companyId: setInventoryStates.companyId,
        });

        await this.setState({ warehouseId: setInventoryStates.warehouseId });
        const singleData = await this.companyStore.getCompanyDataById(
          setInventoryStates.companyId
        );

        await this.setState({ loadList: 1 });
        console.log("singleData", singleData);
        await this.setState({
          companyVal_Lab: singleData,
          companyId: setInventoryStates.companyId,
        });
        console.log("singleData", singleData);
      }

      await this.setState({ listDataUpdate: false });
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination, "pagi");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }
  async handleChange(comp) {
    await this.setState({ companyId: comp.value, warehouseId: "" });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    const data = await this.inventoryStore.getWarehouselist({
      companyId: comp.value,
    });
    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });

    await this.handleSearch();

    console.log("getdata", data);
    await this.setState({ loadList: 1 });
  }

  async handleSearch() {
    await this.inventoryStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      warehouseId: this.state.warehouseId,
      companyId: this.state.companyId,
    });
    console.log(this.state.warehouseId);
    await this.setState({ loadList: 1 });
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.success == "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openInventoryForm: false });

      //  await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    } else {
      message.error("Inventory no Already Exist");
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  closeModal = () => {
    this.setState({ openInventoryForm: false, inventoryId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.inventoryStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_INVENTORY_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
               
                <Tooltip
                  placement="left"
                  // title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({
                        openInventoryForm: true,
                        inventoryId: "",
                      })
                    }
                  ></Button>
                </Tooltip>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                 
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={(value) => this.handleChange(value)}
                  // allowClear={true}
                  style={{ width: 200 }}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                />
                <Select
                  // allowClear
                  style={{ width: 200 }}
                  value={this.state.warehouseId ? this.state.warehouseId : null}
                  onSelect={async (id) => {
                    await this.setState({ warehouseId: id });

                    await this.handleSearch();
                    this.setState({ loadList: 1 });

                    console.log(id);
                  }}
                  // placeholder="Warehouse"
                  placeholder={this.context.translate(
                    "_NAME_GRID_OF_WAREHOUSE_"
                  )}
                  fieldNames={{ value: "id", label: "warehouse" }}
                  optionFilterProp="children"
                  options={this.inventoryStore?.warehouseList}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({
                        searchField: "",
                        userStatus: "",
                        userType: "",
                      });
                    }}
                  ></Image>
                </Tooltip>

                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.menuProps}
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      marginInlineEnd: "20px",
                    }}
                    src={kebabIcon}
                  />
                </Dropdown>

                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({ openInventoryForm: true, inventoryId: "" });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.inventoryStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.inventoryStore?.inventory}
            loading={this.inventoryStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.waslModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>{this.context.translate("_CONFIRM_")}</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ waslModal: false })}
                  />
                </div>
              }
              className="update-statusModal"
              description="Are you sure to change this status?"
              centered
              open={this.state.waslModal}
              footer={null}
              // onOk={this.confirmStatus}
              width={400}
              closable={false}
            >
              <div className="confirmStatusText">
                <p>
                  {this.context.translate("_DOYOU_WANT_TO_REGISTER_")}{" "}
                  {this.state.inventoryName}{" "}
                  {this.context.translate("_IN_WASL_")}
                </p>
              </div>
              <div className="confirmStatusButtons">
                <Button
                  onClick={() => this.setState({ waslModal: false })}
                  className="confirmStatusCancelButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="confirmStatusOkButton"
                  onClick={(e) => {
                    this.regiterWarehouse(this.state.inventoryId);
                    this.setState({ waslModal: false });
                  }}
                >
                  {this.context.translate("_FLEET_RULEDETAIL_ACTIVEDDL_YES_")}
                </Button>
              </div>
            </Modal>
          )}
          {/* <Modal
            // title="Confirm"
            title={
              <span>
                <QuestionCircleOutlined style={{ color: "red" }} />
                &nbsp;
              
                {this.context.translate("_CONFIRM_")}
              </span>
            }
            open={this.state.waslModal}
            onCancel={() => this.setState({ waslModal: false })}
            width={400}
            footer={[
              <div style={{ padding: 10 }}>
                <Button
                  // key="yes"
                  onClick={(e) => {
                    this.regiterWarehouse(this.state.inventoryId);
                    console.log(this.state.inventoryId);
                    this.setState({ waslModal: false });
                  }}
                  type="primary"
                >
                 
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_REMOVEYES_")}
                </Button>
                <Button
                  // key="no"
                  onClick={() => this.setState({ waslModal: false })}
                >
                 
                  {this.context.translate("_FLEET_RULELIST_CRONRULE_NO_")}
                </Button>
              </div>,
            ]}
          >
            <p style={{ margin: "0px 20px" }}>
              
              {this.context.translate("_DOYOU_WANT_TO_REGISTER_")}{" "}
              {this.state.inventoryName} {this.context.translate("_IN_WASL_")}
            </p>
          </Modal> */}

          {this.state.openInventoryForm && (
            // <Modal
            //   bodyStyle={{ height: "637px" }}
            //   className="formShowModal" //
            //   // title="Add Inventory"
            //   title={this.context.translate("_ADD_INVENTORY_")}
            //   centered
            //   visible={this.state.openInventoryForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openInventoryForm: false, inventoryId: "" });
            //   }}
            //   width={665}
            // >
            //   <div>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openInventoryForm}
              footer={false}
              placement={
                this.context.locale.language === "english" ? "right" : "left"
              }
              title={
                <div className="formTitle">
                  {this.context.translate("_INVENTORY_DETAILS_")}
                  <p className="formDescription">
                    {this.context.translate("_INVENTORY_DETAILS_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openInventoryForm: false })}
              onCancel={() =>
                this.setState({ openInventoryForm: false, inventoryId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <InventoryAdd
                  inventoryId={this.state.inventoryId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          {this.state.openDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {" "}
                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                    )}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Are you sure you want to delete this Item? This action cannot be undone."
              centered
              open={this.state.openDeleteModal}
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>
              <div style={{ marginBottom: 20 }}>
                <ConfigProvider
                  theme={{
                    components: {
                      Radio: {
                        colorPrimary: "rgba(217, 45, 32, 0.7)", // dot color
                        colorPrimaryHover: "rgba(217, 45, 32, 0.7)", // hover border
                        colorPrimaryActive: "rgba(217, 45, 32, 0.7)", // focus ring
                      },
                    },
                  }}
                >
                  <Radio.Group
                    className="deleteRadioGroup"
                    onChange={
                      (e) => this.setState({ deleteOption: e.target.value }) // 0 or 1
                    }
                    value={this.state.deleteOption}
                  >
                    <Radio value={1}>Delete from WASL only</Radio>
                    <Radio value={2}>Delete from WASL & Portal</Radio>
                  </Radio.Group>
                </ConfigProvider>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ openDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="deleteModalOkButton"
                  onClick={() => this.onDelete(this.state.deleteData)}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}
        </div>
      </>
    );
  }
}
InventoryList.contextType = StoreContext;
export default observer(withRouter(InventoryList));
